export const ifNaN = (value: number, alternativeValue: number) => isNaN(value) ? alternativeValue : value;
